export var RangeValueProperties;
(function (RangeValueProperties) {
    RangeValueProperties["LOW"] = "low";
    RangeValueProperties["HIGH"] = "high";
})(RangeValueProperties || (RangeValueProperties = {}));
export var ParamLocationType;
(function (ParamLocationType) {
    ParamLocationType["hash"] = "hash";
    ParamLocationType["query"] = "query";
})(ParamLocationType || (ParamLocationType = {}));
